<template>
	<v-app>
		<v-content>
			<router-view/>
		</v-content>
		<v-footer
      app
      color="white"  
      padless    
    >
      <v-row>
        <v-col cols="6" class="primary pl-10 white--text">
          <span class="mr-2 overline">Pablo Ojeda</span>
        </v-col>
        <v-col cols="6" class="primary text-right pr-10 white--text">
          <span class="mr-2 overline">&copy; {{ new Date().getFullYear() }}</span>
        </v-col>
      </v-row>
    </v-footer>
	</v-app>
</template>

<script>
// import Navigation from './components/Navigation'

export default {
	name: 'App',
	components: {
		// Navigation
	},
	data: function() {
		return {
			
		}
	}
};
</script>
